import { Store, Flame, ArrowRight } from "lucide-react";
import { SkillCard } from "@/components/SkillCard";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { PRIMARY, SECONDARY, Reveal, Kicker } from "@/components/landing/shared";

export const MarketplacePreview = ({ skills, start, openGallery, startTeam }) => (
  <section id="marketplace" className="scroll-mt-20 py-16 lg:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <Kicker><Store className="h-3.5 w-3.5" /> Free public gallery</Kicker>
            <h2 className="rb-display text-3xl font-semibold tracking-tight text-[color:var(--rb-text)]">Try it free &mdash; no team required</h2>
            <p className="mt-2 max-w-2xl text-[color:var(--rb-text-dim)]">Browse and download free skills, agents, and commands built by the community. This is the top of the funnel &mdash; when you're ready for a private, governed registry for your own team, it's one click away.</p>
          </div>
          <Button onClick={openGallery} className={`rounded-xl ${SECONDARY}`} data-testid="landing-marketplace-browse">Browse the gallery</Button>
        </div>
      </Reveal>

      <div data-testid="landing-marketplace-grid" className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {skills === null ? (
          Array.from({ length: 6 }).map((_, i) => (
            <div key={`skeleton-${i}`} className="rounded-2xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] p-5">
              <Skeleton className="h-5 w-20 bg-[color:var(--rb-surface)]" />
              <Skeleton className="mt-3 h-5 w-40 bg-[color:var(--rb-surface)]" />
              <Skeleton className="mt-2 h-4 w-full bg-[color:var(--rb-surface)]" />
              <Skeleton className="mt-4 h-4 w-24 bg-[color:var(--rb-surface)]" />
            </div>
          ))
        ) : skills.length === 0 ? (
          <div className="col-span-full flex flex-col items-center rounded-2xl border border-dashed border-[color:var(--rb-border)] py-16 text-center">
            <Flame className="h-8 w-8 text-[color:var(--rb-gold)]" />
            <p className="mt-3 text-[color:var(--rb-text-dim)]">New library &mdash; be one of the first to publish a skill, agent, or tool.</p>
            <Button onClick={start} className={`mt-4 rounded-xl ${PRIMARY}`}>Publish the first one</Button>
          </div>
        ) : (
          skills.slice(0, 6).map((s) => <SkillCard key={s.id} skill={s} onClick={start} />)
        )}
      </div>

      <Reveal delay={0.1}>
        <button onClick={startTeam} data-testid="landing-marketplace-team-cta" className="mt-6 flex items-center gap-1.5 text-sm text-[color:var(--rb-gold)] hover:underline">
          Want this private and governed for your own team? Start a registry <ArrowRight className="h-3.5 w-3.5" />
        </button>
      </Reveal>
    </div>
  </section>
);
